const registeredRouter = {
  path: "/registered",
  name: "registered",
  component: () => import("@/views/Registered")
};

export default registeredRouter;
